<div class="loyalty-bar-chart-container" #barChartContainer></div>
